export function FitScoreBadge({ score }: { score: number }) {
  return (
    <div className="grid h-20 w-20 shrink-0 place-items-center rounded-full border-[6px] border-lime bg-moss text-center text-white shadow-lg">
      <span><b className="block text-xl leading-5">{score}%</b><small className="text-[10px] uppercase tracking-widest">fit</small></span>
    </div>
  );
}
